import { gql } from '@graphql/__generated__';

export const GET_LISTING_BUYERS = gql(/* GraphQL */ `
  query GetListingBuyers($lotId: uuid!) {
    buyer_leads(
      where: { lot_id: { _eq: $lotId } }
      order_by: { updated_at: desc }
    ) {
      user {
        ...UserCardDisplayName
      }
    }
  }
`);

export const GET_DOCUMENT_RECIPIENTS = gql(/* GraphQL */ `
  query GetDocumentRecipients($documentId: String!, $documentType: String) {
    document_recipients(
      document_id: $documentId
      document_type: $documentType
    ) {
      recipients {
        user_id
        name
        total_opens
        unique_opens
        last_open_at
      }
    }
  }
`);

export const TRACKED_BROCHURE_LINK = gql(/* GraphQL */ `
  mutation TrackedBrochureLink(
    $url: String!
    $documentType: String
    $recipientId: String
  ) {
    tracked_document_url(
      url: $url
      document_type: $documentType
      recipient_id: $recipientId
    ) {
      url
    }
  }
`);

export const GET_BROCHURE_RECIPIENT_STATS = gql(/* GraphQL */ `
  query GetBrochureRecipientStats(
    $documentId: String!
    $recipientId: String!
    $from: timestamptz
    $to: timestamptz
  ) {
    document_stats(
      document_id: $documentId
      document_type: "lot_brochure"
      recipient_id: $recipientId
      from: $from
      to: $to
    ) {
      total_opens
      unique_opens
      daily {
        date
        total
        unique
      }
    }
  }
`);
